module.exports = __webpack_public_path__ + "media/images/admin/icons/voicemail-cbc9921fe3f16eca97410f4eb5046692.svg";